import { useEffect, useMemo, useState } from "react";
import { useFetch } from "@hooks/useFetch";
import { getAvailableActivationDates } from "@api-routes/eirSalesFacade";
import { isBefore } from "date-fns";

export const useGetAvailableActivationDates = () => {
    const [getAvailableActivationDatesState, { get }] = useFetch();
    const [activationDatesList, setActivationDatesList] = useState<Date[]>([]);

    const getActivationDates = useMemo(
        () => () => {
            get<Date[]>(getAvailableActivationDates()).then((response) => {
                if (response) {
                    const availableActivationDates = response
                        .map((date) => new Date(date))
                        .sort((prev, curr) => (isBefore(prev, curr) ? -1 : 1));

                    setActivationDatesList(availableActivationDates);
                }
            });
        },
        [get]
    );

    useEffect(getActivationDates, [getActivationDates]);

    return {
        getAvailableActivationDatesState,
        activationDatesList,
        getActivationDates,
    };
};
